import React, { useState } from 'react';
import { Form, Input, Button, Alert } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import { useAuthStore } from '../../store/authUserStore';

const ForgotPassword: React.FC = () => {
    const [form] = Form.useForm();
    const [email, setEmail] = useState('');
    const forgotPassword = useAuthStore((state) => state.forgotPassword);
    const error = useAuthStore((state) => state.error);
    const isLoading = useAuthStore((state) => state.isLoading);
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleSubmit = async (values: { email: string }) => {
        const { email } = values;
        await forgotPassword(email);
        if (!error) {
            navigate('/');
        }
    };

    return (
        <div className="login-bg">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-logo">
                        <img src="/logo.png" alt="Logo" />
                    </div>
                    <h2 className="login-title">{t('general.forgotPassword')}</h2>
                    <Form
                        form={form}
                        onFinish={handleSubmit}
                        layout="vertical"
                        initialValues={{ email }}
                        size="large"
                        className="login-form"
                    >
                        <Form.Item
                            label={t('general.email')}
                            name="email"
                            rules={[
                                { required: true, message: t('general.forgotPasswordEmailRequired') },
                                { type: 'email', message: t('general.forgotPasswordInvalidEmail') }
                            ]}
                        >
                            <Input
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                className="login-input"
                                placeholder={t('general.email')}
                            />
                        </Form.Item>
                        {error && (
                            <Form.Item>
                                <Alert message={error} type="error" showIcon />
                            </Form.Item>
                        )}
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isLoading}
                                className="login-button"
                                block
                            >
                                {t('general.submit')}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
